<h1 class="text-center border-bottom pb-3">Specials: Festo</h1>
<div [ngClass]="{ 'd-none': isLoading }">
  <div class="row">
    <div class="col-lg-6 col">
      <div *ngIf="reservedSpecialSku">
        <app-new-festo-special
          [stats]="stats"
          [reservedSku]="reservedSpecialSku"
          (keepInputs)="setKeepInput($event)"
          (createNewSpecial)="createSpecial($event)"
        ></app-new-festo-special>
      </div>
    </div>
  </div>
  <div>
    <div
      [ngClass]="{
        'd-none': !feedbackSettings.show,
      }"
    >
      <div class="feedback_box">
        <app-feedback
          [(settings)]="feedbackSettings"
          (update)="handleFeedbackOutput($event)"
        ></app-feedback>
      </div>
    </div>
    <app-festo-specials-table [specials]="specials"></app-festo-specials-table>
  </div>
</div>

<app-loading-gears [ngClass]="{ 'd-none': !isLoading }"></app-loading-gears>
